import firebase from 'firebase/app'
import 'firebase/messaging'
import { firebaseConfig } from './firebaseConfig';
import { notification } from 'antd';

function initializeFirebase() {
    firebase.initializeApp(firebaseConfig)
}

function initializePush(registration) {
    const messaging = firebase.messaging()
    messaging.requestPermission()
        .then(() => {
            console.log("have permission")
            const token = messaging.getToken({ serviceWorkerRegistration: registration })
            console.log("token is", token)
            return token
        })
        .then((token) => {
            console.log("FCM token: ", token)
        })
        .catch(error => {
            if (error.code === "messaging/permission-blocked") {
                console.log("Please Unblock Notification Request Manually");
            } else {
                console.log("Error Occurred", error);
            }
        });
    messaging.onMessage((payload) => {
        console.log('FCM Message received. ', payload);
        if (payload.notification) {
            notification.open({
                key: 'fcm-1',
                message: payload.notification.title,
                description: payload.notification.body,
                duration: 30,
                top: 55,
            })
        }
    })
}

export function registerNotification() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                setTimeout(() => {
                    initializeFirebase()
                    initializePush(registration)
                }, 2000)
            })
    }
}
